import React from 'react'
import { Tag } from 'antd'
import { useIntl } from 'react-intl'

export const ADPFlag = () => {

  const { formatMessage } = useIntl ()
  return (
    <Tag color='green'>{formatMessage({ id: 'automations.adpAbbreviation' })}</Tag>
  )
}